var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.198,
    height: 9.822,
    viewBox: "0 0 16.198 9.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -96.417)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 96.417)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23304b",
    d: "M16.066,100.953c-2.447-3.009-5.088-4.536-7.859-4.536a8.237,8.237,0,0,0-3.306.724A11.58,11.58,0,0,0,2.359,98.7a13.256,13.256,0,0,0-2.245,2.271.6.6,0,0,0,.017.727c2.443,3.012,5.088,4.536,7.859,4.536a8.237,8.237,0,0,0,3.306-.724,11.58,11.58,0,0,0,2.542-1.564,13.256,13.256,0,0,0,2.245-2.271A.6.6,0,0,0,16.066,100.953Zm-3,2.089a8.417,8.417,0,0,1-5.078,2.007c-2.285,0-4.513-1.253-6.629-3.726a13.08,13.08,0,0,1,1.765-1.706A8.417,8.417,0,0,1,8.2,97.611c2.285,0,4.513,1.253,6.629,3.726A12.881,12.881,0,0,1,13.068,103.042Z",
    transform: "translate(0 -96.417)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.305 98.54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23304b",
    d: "M165.453,162.812a.6.6,0,0,0-.6.6,1.6,1.6,0,1,1-1.6-1.6.6.6,0,0,0,0-1.19,2.79,2.79,0,1,0,2.79,2.79A.6.6,0,0,0,165.453,162.812Z",
    transform: "translate(-160.467 -160.617)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordView);
export default __webpack_public_path__ + "static/media/passwordView.88397499.svg";
export { ForwardRef as ReactComponent };